import { array, boolean, object, string } from "yup";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";

export const TEACHING_METHODOLOGIES_MIN_ERROR = "Au moins une méthodologie pédagogique est requise";

export const teachingMethodologyItemSchema = object({
  title: string().trim().required(REQUIRED_FIELD),
  description: string().trim().required(REQUIRED_FIELD),
  documentUrl: string().nullable().defined(),
  isPublic: boolean().required(),
});

export const teachingMethodologiesArraySchema = array(teachingMethodologyItemSchema)
  .transform((value, original) => (original == null ? [] : value))
  .min(1, TEACHING_METHODOLOGIES_MIN_ERROR)
  .required(TEACHING_METHODOLOGIES_MIN_ERROR);
